"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconChevronLeft = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var NavigatePrevious = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M6.43934 10.9411C5.85355 11.5269 5.85355 12.4767 6.43934 13.0625L14.2175 20.8406C14.8033 21.4264 15.753 21.4264 16.3388 20.8406C16.9246 20.2549 16.9246 19.3051 16.3388 18.7193L9.62132 12.0018L16.3388 5.28429C16.9246 4.69851 16.9246 3.74876 16.3388 3.16297C15.753 2.57719 14.8033 2.57719 14.2175 3.16297L6.43934 10.9411Z" }))); };
exports.UtilIconChevronLeft = (0, utils_1.withDeprecationWarning)(NavigatePrevious, 'UtilIconChevronLeft');
exports.default = NavigatePrevious;
